import { useState } from "react";
import { Box, Text, useThemeUI } from "theme-ui";
import { useDispatch, useSelector } from "react-redux";

import { useTranslation } from "hooks";
import { selectUserChoiceValues } from "store/app";
import { ToggleText, Button } from "components";
import { displayCompareModal } from "store/app/appSlice";
import { filterByDisplayIf } from "utils";
import * as styles from "./BladePatternGuide.styles";

export default function BladePatternGuide({ groupedPatterns = [] }) {
  const {
    theme: { isMobile },
  } = useThemeUI();

  const { t } = useTranslation();

  const [selectedGroupedPatternIndex, setSelectedGroupedPatternIndex] =
    useState(0);

  const dispatch = useDispatch();

  const userChoiceValues = useSelector(selectUserChoiceValues);

  return (
    <Box sx={styles.bladePatternGuide}>
      {groupedPatterns.length > 1 && (
        <ToggleText
          value={selectedGroupedPatternIndex}
          options={groupedPatterns.map(({ title, shortTitle }, index) => ({
            value: index,
            label: isMobile ? shortTitle : title,
          }))}
          onChange={setSelectedGroupedPatternIndex}
          isRound
        />
      )}

      <Box>
        {groupedPatterns[selectedGroupedPatternIndex].patterns
          .filter((aPattern) =>
            filterByDisplayIf(userChoiceValues)(aPattern.displayIf)
          )
          .map(
            ({ title, description, images = [], details = [], video = {} }) => (
              <Box key={title} sx={styles.pattern}>
                <Box sx={styles.titleContainer}>
                  <Text as="div" variant="h4" mb="20px">
                    {title}
                  </Text>

                  {video.url && (
                    <Button
                      variant="primary"
                      size="small"
                      isRound
                      onClick={() => {
                        dispatch(
                          displayCompareModal({
                            item: title,
                          })
                        );
                      }}
                    >
                      {t("compare")}
                    </Button>
                  )}
                </Box>

                <Box sx={styles.descriptionContainer}>
                  {images.length > 0 && (
                    <Box sx={styles.imagesContainer}>
                      {images.map(({ url }) => (
                        <Box
                          key={url}
                          as="div"
                          sx={styles.image}
                          style={{ backgroundImage: `url(${url})` }}
                        />
                      ))}
                    </Box>
                  )}

                  <Text
                    as="div"
                    variant="copy3Light"
                    dangerouslySetInnerHTML={{ __html: description }}
                    mb="20px"
                  />
                </Box>

                <Box sx={styles.details}>
                  {details.map(({ label, value }) => {
                    return (
                      <Box key={label} sx={styles.detailsItem}>
                        <Text
                          variant="copy3Medium"
                          as="strong"
                          sx={styles.detailsTitle}
                        >
                          {label}
                        </Text>
                        <Text variant="copy3Light">{value}</Text>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            )
          )}
      </Box>
    </Box>
  );
}
